module.exports = __webpack_public_path__ + "img/4.fb77b6fa.png";